import React, { useState, useCallback, useEffect } from "react";
import { addNotification as notify } from "reapop";
import { connect } from "react-redux";
import InputGroup from "../../forms/InputGroup";
import Textarea from "../../forms/Textarea";
import AdminNavigation from "./AdminNavigation";
import { ManageTranslationsDraftDefaultFields } from "./ManageTranslationField";
import { validateField } from "../../pages/functions";
import { api } from "../index.api";
import "./styles.css";
import { REF_DATA } from "../../constants";
import { getApplicationRegex } from "../plugins/utils";

const ManageTranslationsDraft = (props) => {
  const [createDraftState, setCreateDraftState] = useState(false);
  const [draftVersionDetails, setDraftVersionDetails] = useState({});
  const [fields, setFields] = useState(ManageTranslationsDraftDefaultFields);

  const getLiveAndDraftDetails = useCallback(() => {
    api.admin.translation.fetchLiveAndDraftDetails((response) => {
      const draftVersionDetails = response.filter(
        (res) => res.type.toLowerCase() === "draft"
      );
      if (draftVersionDetails.length > 0) {
        setCreateDraftState(true);
        setDraftVersionDetails(draftVersionDetails[0]);
        const liveVersionDetails = response.filter(
          (res) => res.type.toLowerCase() === "live"
        );
        if (liveVersionDetails.length > 0 && fields) {
          setFields((prevState) => ({
            ...prevState,
            currentLiveVersion: {
              ...prevState.currentLiveVersion,
              value: liveVersionDetails[0].version.toString(),
            },
            currentLiveComments: {
              ...prevState.currentLiveComments,
              value: liveVersionDetails[0].versionComments,
            },
            draftVersionComment: {
              ...prevState.draftVersionComment,
              value: draftVersionDetails[0].versionComments,
            },
          }));
        }
      }
    });
  }, [fields]);

  useEffect(() => {
    getLiveAndDraftDetails();
  }, []);

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);
  
      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      validateFields.draftVersionComment.errors = [];
      setFields({ ...validateFields });
    },
    [fields]
  );

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const updateDraftVersionCommentsHandler = (res) => {
    if (res.status === 200) {
      showNotification(
        "Success",
        "Draft version comments updated successfully",
        "success"
      );
    } else {
      showNotification("Error", "Please try again later", "error");
    }
  };

  const handleCreateDraft = () => {
    api.admin.translation.createDraft((res) => {
      if (res.status === 200) {
        showNotification("Success", "Draft created successfully", "success");
        getLiveAndDraftDetails();
        setCreateDraftState(true);
      } else {
        showNotification("Error", "Please try again later", "error");
      }
    });
  };

  const handleDeleteDraft = () => {
    api.admin.translation.deleteDraft(res => {
      if(res.status === 200) {
        showNotification("Success", "Draft deleted successfully", "success");
        getLiveAndDraftDetails();
        setCreateDraftState(false);
      } else {
        showNotification("Error", "Please try again later", "error");
      }
    });
  };

  const handleSaveDraft = () => {
    const copyFields = draftVersionDetails;
    copyFields.versionComments = fields.draftVersionComment.value;
    api.admin.translation.updateDraftVersionComments(
      copyFields,
      updateDraftVersionCommentsHandler
    );
  };

  return (
    <div id="manage-admin-list" className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row manage-admin-list-header">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Manage Translations Draft</h3>
            </div>
          </div>
          {!createDraftState && (
            <div>
              <button
                className="btn btn-lg btn-info btn-rounded"
                onClick={handleCreateDraft}
              >
                Create Draft
              </button>
            </div>
          )}
          {createDraftState && (
            <div className="manageTranslationsDraftBody">
              <div className=" col-md-4">
                <InputGroup
                  type="number"
                  searchable={false}
                  clearable={false}
                  field={fields.currentLiveVersion}
                  disabled={true}
                  validate={(e) => validate(e, fields.currentLiveVersion)}
                />
              </div>
              <div className=" col-md-12">
                <Textarea
                  rows={4}
                  maxLength={4000}
                  field={fields.currentLiveComments}
                  isDisabled={true}
                  validate={(e) => validate(e, fields.currentLiveComments)}
                />
              </div>
              <div className="row draftVersionComment_section">
                <div className="col-lg-12">
                  <Textarea
                    rows={4}
                    maxLength={4000}
                    style={{ borderRadius: "4px" }}
                    field={fields.draftVersionComment}
                    validate={(e) => validate(e, fields.draftVersionComment)}
                  />
                </div>
              </div>
              <div>
                <button
                  className="btn btn-lg btn-info btn-rounded save_button"
                  onClick={handleSaveDraft}
                >
                  Save
                </button>
                <button
                  className="btn btn-lg btn-info btn-rounded"
                  onClick={handleDeleteDraft}
                >
                  Delete Draft
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    referenceData: state.referenceData
  };
}

export default connect(mapStateToProps, { notify })(ManageTranslationsDraft);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/ManageTranslationsDraft.js